import React, { Component } from 'react';
import { Input, Table, FormGroup, FormFeedback, Button } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import TooltipItem from '../../../tools/TooltipItem';
import { IoPersonOutline, IoPersonAddOutline } from 'react-icons/io5'
import { connect } from 'react-redux';

export class DeptSearchData extends Component {
    //The majority of this component is going to be extremely similar to EmpSearchData.js
    constructor(props) {
        super(props);
        this.state = {
            empResponse: [],
            accordionVisible: false,
            activeTab: '1',
            searchType: '',
            userDomain: this.props.reduxData.userInfo.username.charAt(this.props.reduxData.userInfo.username.length - 1) >= 0 && this.props.reduxData.userInfo.username.charAt(this.props.reduxData.userInfo.username.length - 1) <= 9 ? "PERGOLA" : "HOOD",
            returnable: [],
            department: this.props.reduxData.userInfo.level.dept.substring(0, this.props.reduxData.userInfo.level.dept.indexOf("-") - 1),
            departmentpk: this.props.reduxData.userInfo.level.pk,
            phoneUpdateStatus: "",
            roomUpdateStatus: "",
            buildingUpdateStatus: "",
            ipUpdateStatus: "",
            phoneUpdateText: "",
            roomUpdateText: "",
            buildingUpdateText: "",
            ipUpdateText: "",
            deptPermTier: this.props.reduxData.userInfo.level.pk.substring(this.props.reduxData.userInfo.level.pk.indexOf("-") + 1),
            priorUpdateVal: "",
            activeDeptPK: [],
            DTMBuildings: [],
            undoList: []
        }
        this.toggle = this.toggle.bind(this);
        this.getUserInfo();
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        if (stateItem != "" && stateItem != null) {
            this.setState({
                [stateItem]: data
            })
        }
        if (stateItem == "") {
            return data
        }

    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    getUserInfo() {
        //console.log("redux data: ", this.props.reduxData)
        let domainFlag = this.props.reduxData.userInfo.username.charAt(this.props.reduxData.userInfo.username.length - 1)
        if (domainFlag >= '0' && domainFlag <= '9') {
            this.setState({
                userDomain: "PERGOLA"
            })
        }
        else {
            this.setState({
                userDomain: "HOOD"
            })
        }
        //this.getUserDeptPK(this.props.reduxData.userInfo.level.pk)
        this.apiFetch("GetUserDeptPK", {}, "activeDeptPK")
        this.apiFetch("GetDTMBuildings", {}, "DTMBuildings")
    }

    //async getUserDeptPK(dept) {
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: dept
    //    }
    //    const response = await fetch('GetUserDeptPK', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        activeDeptPK: data
    //    })
    //    this.getBuildChange(dept);
    //}

    //async getBuildChange(dept) {
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: dept
    //    }
    //    const response = await fetch('GetDTMBuildings', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        DTMBuildings: data
    //    })
    //}

    componentDidMount() {
        let splitName = "";
        if (this.props.deptName.indexOf(" -- ") <= 0) {
            splitName = this.props.deptName;
        }
        else {
            splitName = this.props.deptName.substring(0, this.props.deptName.indexOf(" -- "))
        }
        let activeDeptPropPK = this.props.empSearch.find((element) => {
            return element.deptName === splitName;
        })
        this.setState({
            activeTab: activeDeptPropPK.pk
            })
    }

    async changeBuild(e, pcid, dept, original, pk) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //this.props.updateFetchTime();
        if (e.target.value == this.state.priorUpdateVal) {
            return;
        }
        let toSend = {}
        if (e.target.value !== "DEFAULT") {
            toSend = {
                //userLevel: this.props.reduxData.userInfo.level.pk,
                userDomain: this.state.userDomain,
                targetpcid: pcid,
                targetdept: dept,
                newvalue: e.target.value,
                changeField: "building"
            }
        }
        else {
            toSend = {
                //userLevel: this.props.reduxData.userInfo.level.pk,
                userDomain: this.state.userDomain,
                targetpcid: pcid,
                targetdept: dept,
                newvalue: original,
                changeField: "building"
            }
        }
        //const response = await fetch('ChangeDirInfo', {
        //    method: 'POST',
        //    headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
        //    body: JSON.stringify(toSend)
        //});
        //const data = await response.json();
        let data = await this.apiFetch("ChangeDirInfo", toSend, "")
        if (data.onestring == "Success") {
            this.setState({
                buildingUpdateStatus: "true"
            })
            setTimeout(() => {
                this.setState({
                    buildingUpdateStatus: ""
                })
            }, 3000)
        }
        else {
            this.setState({
                buildingUpdateStatus: "false",
                buildingUpdateText: data.onestring
            })
        }
        this.setState({
            undoList: [pcid + pk + "building"]
            })
    }

    async changeData(e, pcid, dept, pk, field) {
        e.preventDefault()
        console.log("new value: ", e.target.value)
        console.log("priorUpdateVal: ", this.state.priorUpdateVal)
        if (e.target.value == this.state.priorUpdateVal) {
            return;
        }
        let toSend = {
            userDomain: this.state.userDomain,
            targetpcid: pcid,
            targetdept: dept,
            newvalue: e.target.value,
            changeField: field
        }
        let data = await this.apiFetch("ChangeDirInfo", toSend, "")
        //programmatic feedback and undo function by field param goes here
        let stateValStatus = field + "UpdateStatus"
        let stateValText = field + "UpdateText"
        if (data.onestring == "Success") {
            this.setState({
                [stateValStatus]: "true"
            })
            setTimeout(() => {
                this.setState({
                    [stateValStatus]: ""
                })
            }, 3000)
        }
        else {
            this.setState({
                [stateValStatus]: "false",
                [stateValText]: data.onestring
            })
        }
        this.setState({
            undoList: [pcid + pk + field]
        })
    }

    //async changePhone(e, pcid, dept, pk) {
    //    e.preventDefault();
    //    //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    //this.props.updateFetchTime();
    //    if (e.target.value == this.state.priorUpdateVal) {
    //        return;
    //    }
    //    let toSend = {
    //        //userLevel: this.props.reduxData.userInfo.level.pk,
    //        userDomain: this.state.userDomain,
    //        targetpcid: pcid,
    //        targetdept: dept,
    //        newvalue: e.target.value,
    //        changeField: "phone"
    //    }
    //    //const response = await fetch('ChangeDirInfo', {
    //    //    method: 'POST',
    //    //    headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //    //    body: JSON.stringify(toSend)
    //    //});
    //    //const data = await response.json();
    //    let data = await this.apiFetch("ChangeDirInfo", toSend, "")
    //    if (data.onestring == "Success") {
    //        this.setState({
    //            phoneUpdateStatus: "true"
    //        })
    //        setTimeout(() => {
    //            this.setState({
    //                phoneUpdateStatus: ""
    //            })
    //        }, 3000)
    //    }
    //    else {
    //        this.setState({
    //            phoneUpdateStatus: "false",
    //            phoneUpdateText: data.onestring
    //        })
    //    }
    //    this.setState({
    //        undoList: [pcid + pk + "phone"]
    //        })
    //}

    //async changeRoom(e, pcid, dept, pk) {
    //    e.preventDefault();
    //    //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    //this.props.updateFetchTime();
    //    if (e.target.value == this.state.priorUpdateVal) {
    //        return;
    //    }
    //    let toSend = {
    //        //userLevel: this.props.reduxData.userInfo.level.pk,
    //        userDomain: this.state.userDomain,
    //        targetpcid: pcid,
    //        targetdept: dept,
    //        newvalue: e.target.value,
    //        changeField: "room"
    //    }
    //    //const response = await fetch('ChangeDirInfo', {
    //    //    method: 'POST',
    //    //    headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //    //    body: JSON.stringify(toSend)
    //    //});
    //    //const data = await response.json();
    //    let data = await this.apiFetch("ChangeDirInfo", toSend, "")
    //    if (data.onestring == "Success") {
    //        this.setState({
    //            roomUpdateStatus: "true"
    //        })
    //        setTimeout(() => {
    //            this.setState({
    //                roomUpdateStatus: ""
    //            })
    //        }, 3000)
    //    }
    //    else {
    //        this.setState({
    //            roomUpdateStatus: "false",
    //            roomUpdateText: data.onestring
    //        })
    //    }
    //    this.setState({
    //        undoList: [pcid + pk + "room"]
    //        })
    //}

    //async changeIP(e, pcid, dept, pk) {
    //    e.preventDefault();
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    if (e.target.value == this.state.priorUpdateVal) {
    //        return;
    //    }
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        userDomain: this.state.userDomain,
    //        targetpcid: pcid,
    //        targetdept: dept,
    //        newvalue: e.target.value,
    //        changeField: "ip"
    //    }
    //    const response = await fetch('ChangeDirInfo', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    //localStorage.setItem("lastFetch", moment());
    //    if (data.onestring == "Success") {
    //        this.setState({
    //            ipUpdateStatus: "true"
    //        })
    //        setTimeout(() => {
    //            this.setState({
    //                ipUpdateStatus: ""
    //            })
    //        }, 3000)
    //    }
    //    else {
    //        this.setState({
    //            ipUpdateStatus: "false",
    //            ipUpdateText: data.onestring
    //        })
    //    }
    //    //if (this.state.undoList.indexOf(pcid + pk + "ip") <= -1) {
    //    //    this.setState(prevState => ({
    //    //        undoList: [...prevState.undoList, pcid + pk + "ip"]
    //    //    }))
    //    //}
    //    this.setState({
    //        undoList: [pcid + pk + "ip"]
    //        })
    //}

    async undoButton(pcid, dept, type) {
        let toSend = {
            //userLevel: this.props.reduxData.userInfo.level.pk,
            type: type,
            pcid: pcid,
            department: dept
        }
        //console.log("toSend: " + JSON.stringify(toSend));
        //const response = await fetch('UndoButtonDir', {
        //    method: 'POST',
        //    headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
        //    body: JSON.stringify(toSend)
        //});
        //const data = await response.json();
        const data = await this.apiFetch("UndoButtonDir", toSend, "")
        if (data == true) {

            this.setState({
                undoList: []
                })
            this.props.callbackFunction(data)
        }
    }

    recordVal(e) {
        e.preventDefault();
        this.setState({
            priorUpdateVal: e.target.value
        })
    }

    render() {
        return (
            <div key={this.props.key}>
                {this.props.empSearch.map(deptData => (
                    <div style={{ display: "inline-block" } }><Nav tabs>
                        <NavItem>
                            <TooltipItem id={deptData.pcid + deptData.pk} title={"Division: " + deptData.parentname}>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === deptData.pk })}
                                    onClick={() => this.toggle(deptData.pk)}
                                >
                                    {deptData.deptName}
                                </NavLink>
                            </TooltipItem>
                        </NavItem>
                    </Nav></div>
                ))}
                {this.props.empSearch.map(innerData => (
                    <TabContent activeTab={innerData.pcid + this.state.activeTab}>
                        <TabPane tabId={innerData.pcid + innerData.pk}>
                            <Table bordered hover size="sm" responsive>
                                <tbody>
                                    <tr hidden={this.state.department == "INFO TECHNOLOGY" ? false : true}>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>PCID</b></td>
                                        <td className={"w-75"} id={innerData.pcid} >{innerData.pcid}</td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Title</b></td>
                                        <td className={"w-75"} >{innerData.title}</td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Role</b></td>
                                        <td classname={"w-75"} >{innerData.role} <div className="inlineCustom" style={{ float: 'right' }}>
                                            {innerData.isprimary == "Primary" && <IoPersonOutline />}
                                            {innerData.isprimary == "Secondary" && <IoPersonAddOutline />}
                                        </div></td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Building</b></td>
                                        <td className={"w-75"} >
                                            {this.state.userDomain == "HOOD" && this.state.activeDeptPK.isprimary == true &&
                                                <FormGroup className="inlineCustom">
                                                    <Input
                                                        type="select"
                                                        name="buildChange"
                                                        id="buildChange"
                                                        defaultValue="DEFAULT"
                                                        onChange={(e) => this.changeBuild(e, innerData.pcid, innerData.deptpk, innerData.building, innerData.pk)}
                                                        //onSelect={(e) => this.changeData(e, innerData.pcid, innerData.deptpk, innerData.pk, "building") }
                                                        className="inlineCustom"
                                                        invalid={this.state.buildingUpdateStatus == "false" ? true : false}
                                                        valid={this.state.buildingUpdateStatus == "true" ? true : false}
                                                    >
                                                        <option value="DEFAULT">{innerData.building}</option>

                                                        {this.state.DTMBuildings.filter(remove => remove.name !== innerData.building).map(item => (
                                                            <option>{item.name}</option>
                                                        ))}
                                                    </Input>
                                                    <FormFeedback className="position-relative" tooltip invalid>{this.state.buildingUpdateText}</FormFeedback>
                                                    &nbsp;{this.state.undoList.indexOf(innerData.pcid + innerData.pk + "building") > -1 &&
                                                        <div className="inlineCustom"><Button color="warning" onClick={() => this.undoButton(innerData.pcid, innerData.deptpk, "building")}>Undo</Button></div>
                                                    }
                                            </FormGroup>}
                                            {(this.state.userDomain != "HOOD" || this.state.activeDeptPK.isprimary != true) &&
                                                innerData.building}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Room</b></td>
                                        <td className={"w-75"}><div className="inlineCustom">
                                            {this.state.userDomain == "HOOD" && this.state.activeDeptPK.isprimary == true &&
                                                <FormGroup>
                                                <Input
                                                    type="text"
                                                    name="roomChange"
                                                    id="roomChange"
                                                    defaultValue={innerData.officeRoom}
                                                    onFocus={(e) => this.recordVal(e)}
                                                        //onBlur={(e) => this.changeRoom(e, innerData.pcid, innerData.deptpk, innerData.pk)}
                                                        onBlur={(e) => this.changeData(e, innerData.pcid, innerData.deptpk, innerData.pk, "room") }
                                                    className="inlineCustom"
                                                    invalid={this.state.roomUpdateStatus == "false" ? true : false}
                                                    valid={this.state.roomUpdateStatus == "true" ? true : false}
                                                />
                                                    <FormFeedback className="position-relative" tooltip invalid>{this.state.roomUpdateText}</FormFeedback>
                                            </FormGroup>}
                                            {(this.state.userDomain != "HOOD" || this.state.activeDeptPK.isprimary != true) && innerData.officeRoom}
                                            &nbsp;{this.state.undoList.indexOf(innerData.pcid + innerData.pk + "room") > -1 &&
                                                <div className="inlineCustom"><Button color="warning" onClick={() => this.undoButton(innerData.pcid, innerData.deptpk, "room")}>Undo</Button></div>
                                            }
                                        </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Phone</b></td>
                                        <td className={"w-75"}>
                                            {this.state.userDomain == "HOOD" && this.state.activeDeptPK.isprimary == true &&
                                                <FormGroup className="inlineCustom">
                                                <Input
                                                    type="text"
                                                    name="phoneChange"
                                                    id="phoneChange"
                                                    defaultValue={innerData.phoneEx}
                                                    onFocus={(e) => this.recordVal(e)}
                                                        //onBlur={(e) => this.changePhone(e, innerData.pcid, innerData.deptpk, innerData.pk)}
                                                        onBlur={(e) => this.changeData(e, innerData.pcid, innerData.deptpk, innerData.pk, "phone") }
                                                    className="inlineCustom"
                                                    invalid={this.state.phoneUpdateStatus == "false" ? true : false}
                                                    valid={this.state.phoneUpdateStatus == "true" ? true : false}
                                                />
                                                    <FormFeedback className="position-relative" tooltip invalid>{this.state.phoneUpdateText}</FormFeedback>
                                            </FormGroup>}
                                            {(this.state.userDomain != "HOOD" || this.state.activeDeptPK.isprimary != true) && innerData.phoneEx}
                                            &nbsp;{this.state.undoList.indexOf(innerData.pcid + innerData.pk + "phone") > -1 &&
                                                <div className="inlineCustom"><Button color="warning" onClick={() => this.undoButton(innerData.pcid, innerData.deptpk, "phone")}>Undo</Button></div>
                                            }
                                        </td>
                                    </tr>
                                    <tr hidden={this.state.department == "INFO TECHNOLOGY" ? false : true}>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>PowerCampus User</b></td>
                                        <td classname={"w-75"} >{innerData.pCuser}</td>
                                    </tr>
                                    <tr>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>Email</b></td>
                                        <td className={"w-75"} ><a href={"mailto:" + innerData.email}>{innerData.email}</a></td>
                                    </tr>
                                    <tr hidden={this.state.department == "INFO TECHNOLOGY" ? false : true}>
                                        <td className={"w-25"} style={{ textAlign: 'right' }}><b>IP</b></td>
                                        <td className={"w-75"} >
                                            <FormGroup className="inlineCustom">
                                                <Input
                                                    type="text"
                                                    name="ipChange"
                                                    id="ipChange"
                                                    defaultValue={innerData.ip}
                                                    onFocus={(e) => this.recordVal(e)}
                                                    //onBlur={(e) => this.changeIP(e, innerData.pcid, innerData.deptpk, innerData.pk)}
                                                    onBlur={(e) => this.changeData(e,innerData.pcid, innerData.deptpk, innerData.pk, "ip") }
                                                    className="inlineCustom"
                                                    invalid={this.state.ipUpdateStatus == "false" ? true : false}
                                                    valid={this.state.ipUpdateStatus == "true" ? true : false} />
                                                <FormFeedback className="position-relative" tooltip invalid>{this.state.ipUpdateText}</FormFeedback>
                                            </FormGroup>
                                            &nbsp;{this.state.undoList.indexOf(innerData.pcid + innerData.pk + "ip") > -1 &&
                                                <div className="inlineCustom"><Button color="warning" onClick={() => this.undoButton(innerData.pcid, innerData.deptpk, "ip")}>Undo</Button></div>
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </TabPane>
                    </TabContent>
                ))}
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(DeptSearchData);